import { useId } from "react";

export default function Logo({ size = 34, className = "" }) {
  const rawId = useId();
  const gradId = `huskoPaw-${rawId.replace(/[^a-zA-Z0-9]/g, "")}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00F0FF" />
          <stop offset="1" stopColor="#FF2A85" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="18" fill="#0B0E17" stroke={`url(#${gradId})`} strokeWidth="3" />
      <g fill={`url(#${gradId})`}>
        <ellipse cx="22" cy="24" rx="5.2" ry="7" transform="rotate(-16 22 24)" />
        <ellipse cx="32" cy="20" rx="5.2" ry="7" />
        <ellipse cx="42" cy="24" rx="5.2" ry="7" transform="rotate(16 42 24)" />
        <path d="M32 30.5c-7.4 0-13.2 5.4-13.2 11.7 0 4.2 3.3 6.8 7.4 6.8 2.5 0 4.2-1 5.8-1s3.3 1 5.8 1c4.1 0 7.4-2.6 7.4-6.8 0-6.3-5.8-11.7-13.2-11.7z" />
      </g>
    </svg>
  );
}
